import React, { useState, useEffect } from 'react'
import DemandsTimeline from '../DemandsTimeline'

import styles from './index.module.scss'

function ResumeSidebar({
	timeline,
	currentStep,
	attachments,
	createdAt,
	status,
}) {
	const statusDict = {
		1: 'Solicitando',
		2: 'Em análise gestora',
		3: 'Em análise técnica',
		4: 'Em análise de diretoria',
		5: 'Em análise jurídica',
		6: 'Aprovação final',
		7: 'Aprovado',
	}

	const [currentVersion, setCurrentVersion] = useState({})

	useEffect(() => {
		setCurrentVersion(attachments[attachments.length - 1] || {})
	}, [attachments])

	return (
		<aside className={styles.sidebar}>
			<section className={styles.section}>
				<h3 className={styles.sectionTitle}>Resumo</h3>

				<div className={`${styles.card} ${styles.cardHighlight}`}>
					<span className={styles.cardValue}>
						{statusDict[currentStep] || status}
					</span>
					<span className={styles.cardLabel}>Status</span>
				</div>

				<div className={styles.card}>
					<span className={styles.cardValue}>
						V{currentVersion?.version_number || 1}
					</span>
					<span className={styles.cardLabel}>Versão</span>
				</div>

				<div className={styles.card}>
					<span className={styles.cardValue}>
						{new Date(createdAt).toLocaleDateString('pt-BR')}
					</span>
					<span className={styles.cardLabel}>Criado em</span>
				</div>

				<div className={styles.card}>
					<span className={styles.cardValue}>{timeline.length - 1}</span>
					<span className={styles.cardLabel}>Interações</span>
				</div>
			</section>

			<DemandsTimeline timeline={timeline} currentStep={currentStep} />
		</aside>
	)
}

export default ResumeSidebar
